var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center",staticStyle:{"position":"relative","height":"60vh","width":"100%"}},[_c('LineChart',{staticClass:"px-auto",attrs:{"id":"countChart","options":{ responsive: true },"data":{
            labels: _vm.chartDataFinal.map(row => row.date),
            datasets:[
                {   
                    fill: 'origin',
                    label: 'Qnt. de Redações',
                    borderColor: '#36A2EB',
                    backgroundColor: '#9BD0F5',
                    data: _vm.chartDataFinal.map(row => row.qnt),
                    tension: 0.1
                },
                {   
                    fill: 'origin',
                    label: 'Media',
                    backgroundColor: '#3866af',
                    borderColor: '#3866af',
                    data: _vm.chartDataFinal.map(row => row.avg),
                    tension: 0.1
                }
            ]
        }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }